export default __webpack_public_path__ + "static/media/admon_icon_white.36def916.svg";